module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-4.a4530b2e.jpg";